import Button from '../../../base/button';
import { enums } from '../../../../utils';
import { useEffect, useState } from 'react';
import { Input } from '@progress/kendo-react-inputs';
import { FieldRenderProps } from '@progress/kendo-react-form';
import styled from 'styled-components';

export interface IRadioButtonGroupProps extends FieldRenderProps {
  // CMS-configured (Props Template) answer applied when the field has no value yet
  defaultAnswer?: string;
}

export const RadioButtonsGroupStyled = styled.div<{
  $optionsCount: number;
  $totalCharacters: number;
}>`
  display: flex;
  flex-direction: ${(props) =>
    props.$optionsCount > 2 && props.$totalCharacters > 12 ? 'column' : 'row'};
  max-width: ${(props) => props.$optionsCount > 2 && '500px'};
`;

export const RadioButton = styled(Button).attrs(
  (props: { length: number }) => ({
    length: props.length,
  }),
)`
  margin-bottom: 1em;
  margin-left: ${(props) => props.length > 2 && '0px'};
  margin-right: 10px;
`;

export const handleOnClick = (
  e: any,
  props: FieldRenderProps,
  data: string,
  setSelected: any,
) => {
  e.preventDefault();
  props.onChange({ value: data, target: { value: data } });
  props.onBlur();
  return setSelected(data);
};

export const onChange = (props: FieldRenderProps, selected: any) =>
  props.onChange({ value: selected, target: { value: selected } });

export const isButtonSelected = (data: string, props: FieldRenderProps) => {
  if (data) {
    if (data.toString() === props.value) {
      return enums.ButtonTypes.primary;
    } else {
      return enums.ButtonTypes.secondary;
    }
  } else {
    return enums.ButtonTypes.secondary;
  }
};

const RadioButtonGroup = (props: IRadioButtonGroupProps) => {
  const [selected, setSelected] = useState();

  useEffect(() => {
    if (
      props.defaultAnswer !== undefined &&
      props.value === undefined &&
      !props.touched
    ) {
      props.onChange({
        value: props.defaultAnswer,
        target: { value: props.defaultAnswer },
      });
    }
    // only ever apply the CMS default once, on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    (props?.data && (
      <RadioButtonsGroupStyled
        id={`${props.id}-group`}
        className={props?.classnames && props.classnames}
        $optionsCount={props.data.length}
        $totalCharacters={props.data.reduce(
          (total: number, value: string) => total + value.length,
          0,
        )}
      >
        {props.data.map((value: string, index: number) => (
          <RadioButton
            id={`${props.id}-${index}`}
            key={`key-${index.toString()}`}
            length={parseInt(props.data.length)}
            buttonStyle={isButtonSelected(value, props)}
            onClick={(e: any) => handleOnClick(e, props, value, setSelected)}
            disabled={props.disabled}
          >
            {value?.toString()}
          </RadioButton>
        ))}
        <Input
          hidden
          id={`${props.id}-value`}
          name={props.name}
          value={props.value}
          onChange={() => onChange(props, selected)}
        />
      </RadioButtonsGroupStyled>
    )) ||
    null
  );
};

export default RadioButtonGroup;
